import React, { useState, useRef, useEffect } from "react";
import { useCurrency, CURRENCIES } from "../../context/CurrencyContext";
import "./CurrencySelector.css";

const CurrencySelector = () => {
  const { currency, setCurrency } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="cs" ref={ref}>
      <button className="cs__trigger" onClick={() => setOpen(o => !o)}>
        <span className="cs__flag">{currency.flag}</span>
        <span className="cs__code">{currency.code}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"
          style={{ transform: open ? "rotate(180deg)" : "", transition: "transform .2s" }}>
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </button>

      {open && (
        <div className="cs__drop">
          <p className="cs__drop-label">Select Country / Currency</p>
          {CURRENCIES.map(c => (
            <button
              key={c.code}
              className={`cs__item${currency.code === c.code ? " active" : ""}`}
              onClick={() => { setCurrency(c); setOpen(false); }}
            >
              <span className="cs__flag">{c.flag}</span>
              <span className="cs__country">{c.country}</span>
              <span className="cs__cur-info">{c.symbol} {c.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
